import {
    Button,
    ButtonProps,
    DateInput,
    FormDataConsumer,
    FormWithRedirect,
    SelectInput,
    useListContext,
    useNotify,
    useRefresh,
} from "react-admin";
import {
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
} from "@material-ui/core";
import { useState } from "react";
import { client } from "../../dataProvider";
import { FormSaveButton } from "../../components/FormSaveButton";
import IconCancel from "@material-ui/icons/Cancel";
import { AutocompleteInput, ReferenceInput } from "ra-ui-materialui";
import { FaEdit } from "react-icons/fa";

export interface BulkChangeStatusReceiptButtonProps {
    type?: string;
    button_props?: ButtonProps;
}

export const BulkChangeStatusReceiptButton = (
    props: BulkChangeStatusReceiptButtonProps
) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const refresh = useRefresh();
    const notify = useNotify();
    const { selectedIds, refetch } = useListContext();

    const handleSubmit = async (values: any) => {
        setLoading(true);

        try {
            await client("bank_receipt/bulk_change_status", {
                method: "POST",
                data: {
                    ...values,
                    ids: selectedIds,
                },
            });

            notify("Fatto!", "success");
            setOpen(false);
            refresh();
            refetch();
        } catch (response: any) {
            notify(response?.response?.data?.error || "ra.message.error", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                {...props.button_props}
                disabled={loading || selectedIds.length <= 0}
                label="Cambia stato"
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen(true);
                }}
            >
                {loading ? <CircularProgress size={18} thickness={2} /> : <FaEdit />}
            </Button>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <FormWithRedirect
                    save={handleSubmit}
                    render={({ handleSubmitWithRedirect, pristine }) => (
                        <>
                            <DialogContent>
                                <SelectInput
                                    fullWidth
                                    label="Stato"
                                    source="receipt_status"
                                    optionText="display_name"
                                    optionValue="value"
                                    choices={[
                                        {
                                            display_name:
                                                props.type === "S" ? "Incassata" : "Pagata",
                                            value: "CA",
                                        },
                                        {
                                            display_name: "Insoluta",
                                            value: "US",
                                        },
                                        {
                                            display_name:
                                                "Insoluta e pagata con altro metodo di pagamento",
                                            value: "PA",
                                        },
                                    ]}
                                />

                                <FormDataConsumer>
                                    {({ formData }) =>
                                        formData.receipt_status === "US" ? (
                                            <>
                                                <Typography variant="h6">
                                                    Puoi inserire una data per creare una nuova riba
                                                    relativa alla fattura
                                                </Typography>
                                                <DateInput
                                                    fullWidth
                                                    source="new_expiration_date"
                                                    label="Scadenza"
                                                />
                                            </>
                                        ) : formData.receipt_status === "PA" ? (
                                            <>
                                                <Typography variant="h6">
                                                    Incassa con un altro metodo di pagamento
                                                </Typography>
                                                <ReferenceInput
                                                    reference="payment-terms"
                                                    source="payment_terms"
                                                    perPage={10000}
                                                    fullWidth
                                                    label="Termini di pagamento"
                                                >
                                                    <AutocompleteInput optionText="label" />
                                                </ReferenceInput>
                                            </>
                                        ) : null
                                    }
                                </FormDataConsumer>
                            </DialogContent>

                            <DialogActions>
                                <Button
                                    label="ra.action.cancel"
                                    onClick={() => setOpen(false)}
                                >
                                    <IconCancel />
                                </Button>

                                <FormSaveButton
                                    handleSubmit={() => handleSubmitWithRedirect?.()}
                                    submitting={loading}
                                    pristine={pristine}
                                    label="Conferma"
                                />
                            </DialogActions>
                        </>
                    )}
                />
            </Dialog>
        </>
    );
};